import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Download",
  "use": "Download-usage",
  "viewBox": "0 0 56 58",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 56 58\" id=\"Download\"><path fill-rule=\"evenodd\" d=\"M33.004 34.668L44 27l4 6-19.31 13.764L9 32l4.728-5.5 11.276 8.423V0h8v34.668zM0 49.396h56v8H0v-8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol